import type { ConferenceRankingItem } from "./conferenceRankings";

export function getUpcomingConferencesTableItemTemplate(item: ConferenceRankingItem & { thumbnailUrl?: string }) {
    const location = item.isOnline ? "Online" : item.address || item.location || "TBD";

    let conferenceDate = "TBD";
    if (item.startDate) {
        conferenceDate =
            item.endDate && item.startDate !== item.endDate ? `${item.startDate} - ${item.endDate}` : item.startDate;
    } else if (item.conferenceDate) {
        conferenceDate = item.conferenceDate;
    }

    return `
    <div class="cols conference-item rankings-content__item">
      <span class="col col--1 px-0 py-0 hide-tablet img">
        ${item.thumbnailUrl ? `<img class="lazyload" src="${item.thumbnailUrl}" onerror="this.src='/classic-rankings-frontend/images/article-placeholder.png'" alt="${item.publisher.name}" loading="lazy" />` : ""}
      </span>
      <div class="col col--3 py-0 info">
        <h4><a href="/conference/${item.slug}" class="text-primary hover:underline" target="_blank">${item.name}</a></h4>
        <div class="text-sm mt-1">
          <span>${conferenceDate}</span>
          <span class="mx-1">·</span>
          <span class="font-semibold">${location}</span>
        </div>
      </div>
      <span class="col col--2 py-0 cols mx-0 hide-tablet rankings-info">
        <span class="col col--3 py-0 ranking no-wrap">
            <span class="col col--3 py-0 ranking no-wrap">${item.dIndex ?? "-"}</span>
        </span>
        <span class="col col--3 py-0 ranking no-wrap">
            ${item.dateDue || "TBD"}
        </span>
      </span>
    </div>
    `;
}
